import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form"

import AddItem from "./add-item"
import DateField from "./date-field"
import IntervalField from "./interval-field"

const TrashButton = ({onClick}) => {
  return (
    <button type="button" className="btn btn-sm btn-danger" onClick={onClick} >
      <span className="fa fa-trash"/>
    </button>
  )
}
TrashButton.propTypes = {onClick: PropTypes.func.isRequired}

const PencilButton = ({id, reservationId, onEdit}) => {
  return (<a className='edit-recurring-pencil clickable' onClick={() => onEdit({gameId: reservationId, recurringId: id}) }>
    <span className="fa fa-pencil" />
  </a>)
}
PencilButton.propTypes = {id: PropTypes.number.isRequired, reservationId: PropTypes.number.isRequired}

const isCurrentGameFlag = (v) =>
  v && (v.isCurrentGame === true || v.isCurrentGame === "true")

const Items = ({fields, currentValues, reservationId, defaultDate, onEdit}) => {
  const rows = currentValues || []
  const hasThisGame = rows.some(isCurrentGameFlag)
  const everyRowIndex = hasThisGame
    ? rows.findIndex((v) => v && !isCurrentGameFlag(v))
    : -1
  let showDateRowIndex = 0
  if (hasThisGame && everyRowIndex >= 0) {
    showDateRowIndex = everyRowIndex
  }
  const everyLabelRowIndex = hasThisGame && everyRowIndex >= 0 ? everyRowIndex : 0
  const showDateLabels = (index) => index === showDateRowIndex

  return (
    <div>
      {fields.map((item, index) => {
        const itemValues = currentValues[index]
        const recurringId = itemValues?.id
        let leftLabel = null
        if (isCurrentGameFlag(itemValues)) {
          leftLabel = "This game"
        } else if (index === everyLabelRowIndex) {
          leftLabel = "Every:"
        }
        return (
          <div key={index} className="edit-recurring-item">
            <div className="edit-recurring-fields">
              <Field name={`${item}id`} component="input" type="hidden" />
              <Field name={`${item}isCurrentGame`} component="input" type="hidden" />
              { recurringId && <PencilButton id={itemValues.id} reservationId={reservationId} onEdit={onEdit} /> }
              <IntervalField item={item} currentValues={itemValues} label={leftLabel} />
              <DateField name={`${item}startDate`} label={showDateLabels(index) ? "Start date:" : null}
                defaultDate={recurringId ? null : defaultDate} />
              <DateField name={`${item}endDate`} label={showDateLabels(index) ? "End date:" : null}
                defaultDate={recurringId ? null : defaultDate} />
              <TrashButton onClick={() => fields.remove(index)} />
            </div>
          </div>
        )
      })}
      <AddItem fields={fields} defaultDate={defaultDate} />
    </div>
  )
}

Items.propTypes = {
  fields: PropTypes.object,
  currentValues: PropTypes.array,
  reservationId: PropTypes.number.isRequired,
  defaultDate: PropTypes.string,
  onEdit: PropTypes.func
}

export default Items
